import { Component } from '@angular/core';

@Component({
  selector: 'app-delete-user',
  templateUrl: './delete-user.component.html',
  styleUrls: ['./delete-user.component.scss'],
})
export class DeleteUserComponent {
  errorMessage = '';
  isSentRequest = false;

  // constructor(public user: User) {}

  deleteUser() {
    // this.isSentRequest = true;
    // this.userService.deleteUser(this.user.id).subscribe((response: any) => {
    //   this.matDialogRef.close(true);
    // }, (error: { statusText: string; }) => {
    //   this.errorMessage = error.statusText;
    //   this.isSentRequest = false;
    // });
  }
}
